module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/one-title.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', [_vm._v("\n      自然人投资者中的本机构从业人员需要按照以下准备材料，并将资料图片发送给理财经理\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-main"
  }, [_c('div', {
    staticClass: "share-main-title"
  }, [_vm._v("\n      请准备以下材料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "share-main-content",
    staticStyle: {
      "padding": "35px 20px"
    }
  }, [_c('div', {
    staticClass: "share-content"
  }, [_vm._v("\n        1、身份证正反面照片（或扫描件）；\n        "), _c('br'), _vm._v("\n        2、在职证明，或者社保证明，或者劳动合同扫描件；\n        "), _c('br'), _vm._v("\n        3、投资者基本信息表（自然人）相关信息；\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-download"
  }, [_c('img', {
    attrs: {
      "width": "160px",
      "src": require("../../../common/images/share-download.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#B99558",
      "text-align": "center",
      "font-size": "13px"
    }
  }, [_vm._v("\n    为了顺利完成线上签约，请识别二维码下载APP\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [_c('div', {
    staticClass: "Android"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Android")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "IOS"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("IOS")]), _vm._v(" "), _c('div', {
    staticClass: "erweima-img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../common/images/erweima.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c9250b0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/page/three.vue
// module id = 1016
// module chunks = 1